'use client'

import { Skeleton } from '@/components/skeleton'
import { RestaurantCardSkeleton } from '@/features/restaurants/restaurant-card/restaurant-card-skeleton'
import { RestaurantCardsProvider } from '@/features/restaurants/restaurant-card/restaurant-cards-context'
import { SEARCH_RESULTS_CLASS_NAME } from '@/features/restaurants/restaurants-city-search/restaurant-city-search-results'
import { range } from '@/utils/functions/range'

/** Mirrors the city page: header block, category circles, control row, card grid */
export const CitySkeleton = () => {
    return (
        <div className="flex w-full flex-col pt-4 md:pt-0">
            {/* Breadcrumbs, headline, brands link */}
            <Skeleton className="h-5 w-40 mb-2 md:mb-3" />
            <Skeleton className="h-9 md:h-11 w-64 md:w-96" />
            <Skeleton className="h-5 w-44 mt-3" />

            {/* Category circles */}
            <div className="mt-4 md:mt-6 flex gap-x-1 md:gap-x-2 overflow-hidden">
                {range(10).map((_, index) => (
                    <div
                        key={'city-skeleton-category' + index}
                        className="flex w-[72px] md:w-20 shrink-0 flex-col items-center gap-y-1.5 py-1"
                    >
                        <Skeleton className="size-14 md:size-16 rounded-full" />
                        <Skeleton className="h-3 w-12" />
                    </div>
                ))}
            </div>

            {/* Open now, search, sorting */}
            <div className="mt-4 flex flex-col gap-y-3 md:flex-row md:items-center md:gap-x-3">
                <Skeleton className="h-12 w-full rounded-full md:order-2 md:w-auto md:flex-1" />

                <div className="flex items-center justify-between gap-x-3 md:contents">
                    <Skeleton className="h-12 w-36 rounded-full md:order-1" />
                    <Skeleton className="h-12 w-40 rounded-full md:order-3" />
                </div>
            </div>

            <div className="mt-4 md:mt-6" />

            <div className="w-full flex flex-col">
                <div className={SEARCH_RESULTS_CLASS_NAME}>
                    <RestaurantCardsProvider styleType="default">
                        {range(6).map((_, index) => (
                            <RestaurantCardSkeleton key={'city-skeleton-card' + index} />
                        ))}
                    </RestaurantCardsProvider>
                </div>
            </div>
        </div>
    )
}
